/* eslint-disable */
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-home',
  templateUrl: './client-home.component.html',
  styleUrls: ['./client-home.component.scss'],
})
export class ClientHomeComponent implements OnInit {

  public appPages = [
    { title: 'gestion clientel', url: 'userList', icon: 'mail' },
  ];

  constructor() { }

  ngOnInit() {}

}
